import { Input } from "@chakra-ui/react";

// Поле для шестизначного кода из письма
const CodeInput = ({ value, onChange, onComplete, autoFocus = true }) => (
  <Input
    value={value}
    onChange={(e) => {
      const digits = e.target.value.replace(/\D/g, "").slice(0, 6);
      onChange(digits);
    }}
    onKeyDown={(e) => {
      if (e.key === "Enter" && onComplete) onComplete();
    }}
    onPaste={(e) => {
      const digits = (e.clipboardData.getData("text") || "")
        .replace(/\D/g, "")
        .slice(0, 6);
      if (digits) {
        e.preventDefault();
        onChange(digits);
      }
    }}
    autoFocus={autoFocus}
    inputMode="numeric"
    autoComplete="one-time-code"
    placeholder="______"
    maxLength={6}
    textAlign="center"
    fontSize="28px"
    fontWeight={600}
    letterSpacing="0.42em"
    textIndent="0.42em"
    h="60px"
    borderRadius="14px"
    color="#243D27"
  />
);

export default CodeInput;
